import Home from '@/components/Home';
import Callback from '@/components/Callback';
import EditDealers from '@/components/edit-dealers';
import MaintainTerms from '@/components/admin/maintain-termsConditions';
import Login from '@/components/login';
import store from './store';
import MaintainHandsets from '@/components/maintain-handsets';
import MaintainRatePlans from '@/components/maintain-rateplans';
import CreateKayako from '@/components/admin/create-kayako';
import AppBlank from '@/components/app-blank';
import MaintainRoutes from '@/components/admin/maintain-routes';
import FieldOptions from '@/components/admin/field-options';
import ResourceList from '@/components/dealerportal/resources-list';
import MaintainResouces from '@/components/admin/maintain-resources';
import DealerInterest from '@/components/dealerportal/dealer-interest';
import DealerRegister from '@/components/dealerportal/dealer-register';
import DealerContract from '@/components/dealerportal/edit-dealer-contract';
import InProgressOrders from '@/components/order-inprogress';
import DealerMissing from '@/components/dealerportal/missing-dealer';
import AuditLogs from '@/components/admin/audit-logs';
import AdminQantas from '@/components/admin-qantas';
import ManageAdmin from '@/components/manage-admin';
import BundleManagement from '@/components/admin/bundle-management';
import HardwareOrders from '@/components/mia/hardware-orders';
import WholesalerDetails from '@/components/maintain-wholesaler-details';
import CustomerContact from '@/components/maintain-customer-contact';
import FailedQantasPoints from '@/components/qantas/failed-qantas-points';
import ManageIseekWholesaler from '@/components/manage-iseek-wholesaler';
import ManageCommissionTarget from '@/components/manage-commission-target';
import ScheduledReports from '@/components/scheduled-reports';
import ManageKayako from '@/components/manage-kayako';
import Maintain5GOrders from '@/components/5g/maintain-5g-orders';
import MenuManagement from '@/components/admin/menu-management';
import LinkManagement from '@/components/admin/link-management';
import Unauthorised from '@/components/unauthorised';
import PbxDomains from '@/components/admin/pbx-domains';
import Employees from '@/components/employees';
import NBNHardware from   '@/components/admin/nbn-hardware-management';
import DailyUsageNotificationLogs from '@/components/admin/daily-usage-notification-logs';
import { authGuard } from '@/auth';
function loadView(view) {
  return () =>
    import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`);
}

function loadComponentForTesting(path) {
  return () =>
    import(/* webpackChunkName: "view-[request]" */ `@/components/${path}.vue`);
}

const isAdmin = (to, from, next) => {
  if (store) {
    let user = store.getters['userPermissions/user'];
    let permissions = store.getters['menuPermissions/rows'];
    let availableRoutes = [];
    let toPath = to.path.replace('/', '').toLowerCase();

    let menuPermission = permissions.find(item => item.route == toPath);

    if (
      store.getters['orders/isAdmin'] &&
      menuPermission.authGroups.includes(store.getters['orders/authGroup'])
    ) {
      next();
      return;
    } else next('/unauthorised');
  }
};

const Attachments = {
  props: ['General', 'Licence', 'Business Card', 'Bill'],
  template: '<div>User {{ id }}</div>',
};
export const routes = [
  {
    path: '/',
    component: Home,
    name: 'home',
  },

  {
    path: '/app-status',
    component: AppBlank,
    name: 'appStatus',
  },
  {
    path: '/edit-dealers',
    component: EditDealers,
    name: 'EditDealers',
    beforeEnter: isAdmin,
  },
  {
    path: '/employees',
    component: Employees,
    name: 'Employees',
    beforeEnter: isAdmin,
  },
  {
    path: '/callback',
    name: 'callback',
    component: Callback,
  },

  {
    path: '/admin-qantas',
    name: 'adminQantas',
    component: AdminQantas,
    beforeEnter: isAdmin,
  },
  {
    path: '/failed-qantas-points',
    name: 'failedQantasPoints',
    component: FailedQantasPoints,
    beforeEnter: isAdmin,
  },
  {
    path: '/hardware-orders',
    name: 'hardwareOrders',
    component: HardwareOrders,
    beforeEnter: isAdmin,
  },
  {
    path: '/maintain-handsets',
    component: MaintainHandsets,
    name: 'Handsets',
    style: 'glyphicon glyphicon-education',
    beforeEnter: isAdmin,
    meta: {
      requireAuth: true,
      AdminAuth: true,
    },
  },
  {
    path: '/maintain-bundles',
    name: 'Bundle Management',
    component: BundleManagement,
    beforeEnter: isAdmin,
  },
  {
    path: '/maintain-nbn-hardware',
    name: 'NBN Hardware',
    component: NBNHardware,
    beforeEnter: isAdmin,
  },
  {
    path: '/maintain-rateplans',
    component: MaintainRatePlans,
    name: 'RatePlans',
    style: 'glyphicon glyphicon-education',
    beforeEnter: isAdmin,
    meta: {
      requireAuth: true,
      AdminAuth: true,
    },
  },
  {
    path: '/maintain-5g-orders',
    component: Maintain5GOrders,
    name: '5GOrders',
    style: 'glyphicon glyphicon-education',
    beforeEnter: isAdmin,
    meta: {
      requireAuth: true,
      AdminAuth: true,
    },
  },
  {
    path: '/maintain-wholesaler-details',
    component: WholesalerDetails,
    name: 'WholesalerDetails',
    style: 'glyphicon glyphicon-education',
    beforeEnter: isAdmin,
    meta: {
      requireAuth: true,
      AdminAuth: true,
    },
  },
  {
    path: '/maintain-customer-contact',
    component: CustomerContact,
    name: 'CustomerContact',
    style: 'glyphicon glyphicon-education',
    beforeEnter: isAdmin,
    meta: {
      requireAuth: true,
      AdminAuth: true,
    },
  },
  {
    path: '/maintain-terms',
    component: MaintainTerms,
    name: 'maintainterms',
    beforeEnter: isAdmin,
  },
  {
    path: '/create-kayako',
    component: CreateKayako,
    name: 'CreateKayako',
    beforeEnter: isAdmin,
  },
  {
    path: '/callbackKayako',
    name: 'callbackKayako',
    component: CreateKayako,
  },
  {
    path: '/maintain-routes',
    name: 'maintainRoutes',
    component: MaintainRoutes,
    beforeEnter: isAdmin,
  },
  {
    path: '/resources-list',
    name: 'ResourceList',
    component: ResourceList,
    beforeEnter: authGuard,
  },
  {
    path: '/maintain-resources',
    name: 'MaintainResouces',
    component: MaintainResouces,
    beforeEnter: isAdmin,
  },
  {
    path: '/dealer-register',
    name: 'DealerRegister',
    component: DealerRegister,
    beforeEnter: authGuard,
  },
  {
    path: '/dealer-interest',
    name: 'DealerInterest',
    component: DealerInterest,
    beforeEnter: isAdmin,
  },
  {
    path: '/edit-dealer-contract',
    name: 'DealerContract',
    component: DealerContract,
    beforeEnter: isAdmin,
  },
  {
    path: '/missing-dealer',
    name: 'Missing Dealer',
    component: DealerMissing,
    beforeEnter: isAdmin,
  },
  {
    path: '/order-inprogress',
    name: 'OrderInProgress',
    component: AuditLogs,
    beforeEnter: isAdmin,
  },
  {
    path: '/audit-logs',
    name: 'AuditLogs',
    component: AuditLogs,
    beforeEnter: isAdmin,
  },
  {
    path: '/daily-usage-notification-logs',
    component: DailyUsageNotificationLogs,
    name: 'dailyUsageNotificationLogs',
    beforeEnter: isAdmin,
  },
  {
    path: '/manage-admin',
    component: ManageAdmin,
    name: 'manageadmin',
    beforeEnter: isAdmin,
  },
  {
    path: '/manage-iseek-wholesaler',
    component: ManageIseekWholesaler,
    name: 'manageIseekWholesaler',
    beforeEnter: isAdmin,
  },
  {
    path: '/manage-commissions-targets',
    component: ManageCommissionTarget,
    name: 'manageCommissionsTargets',
    beforeEnter: isAdmin,
  },
  {
    path: '/scheduled-reports',
    component: ScheduledReports,
    name: 'scheduledReports',
    beforeEnter: isAdmin,
  },
  {
    path: '/manage-kayako',
    component: ManageKayako,
    name: 'manageKayako',
    beforeEnter: isAdmin,
  },
  {
    path: '/api',
    name: 'API',
    beforeEnter() {
      //buttons here

      //. beforeEnter: ifNotAuthenticated,
      location.href = 'https://sogapi.vonex.com.au';
    },
  },
  {
    path: '/login',
    name: 'login',
    component: loadView('Login'),
  },
  {
    path: '/wholesalers',
    name: 'wholesalers',
    component: loadView('Wholesalers'),
  },
  {
    path: '/order-types',
    name: 'orderType',
    component: loadComponentForTesting('pages/create-order/order-type'),
  },
  {
    path: '/field-options',
    component: FieldOptions,
    name: 'fieldOptions',
    beforeEnter: isAdmin,
  },
  {
    path: '/link-management',
    component: MenuManagement,
    name: 'menu',
    beforeEnter: isAdmin,
  },
  {
    path: '/menu-management-2',
    component: LinkManagement,
    name: 'links',
    // beforeEnter: isAdmin,
  },
  {
    path: '/pbx-domains',
    component: PbxDomains,
    name: 'pbxdomains',
    // beforeEnter: isAdmin,
  },
  {
    path: '/unauthorised',
    component: Unauthorised,
    name: 'unauthorised',
  },
];
